module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "pro"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("PROLOGUE")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('p', {
    staticClass: "chapterDateline",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "0%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Somewhere in Northern Argentina")])])])]), _c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("“G")])])])]), _vm._v("et on the plane!”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No!”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Brice Whelan squinted through the rain falling all around him, his patience wearing as thin as his soaked black cotton T-shirt.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“We don’t have time to argue, Selena. You have to get on this plane! Now!”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The slender woman scowling up at him pushed at her wet burnished-brown hair and shook her head. “I can’t leave my villagers, Brice. I didn’t call you down here to rescue me. I wanted you to help me! I won’t go.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Brice wrapped a rough hand around her arm, using brute strength to propel her toward the plane. Her returning resistance surprised him—she was a tiny bit of a thing—not more than a hundred pounds at best, but she showed remarkable strength. And she was also remarkably stubborn to boot. Double trouble.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('span', [_vm._v("Brice lifted his eyes to the fury of the heavens, wondering why he was standing here in the middle of a rain ")])]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("forest when he could have been sitting by a nice fire back home in Ireland or maybe watching a baseball game on television at his second home in Atlanta, Georgia. Then he remembered—CHAIM, the elite secretive Christian organization that worked to protect and help Christians in need all over the world. As a member of CHAIM, he had a duty to bring Selena Carter, a missionary nurse who helped run a clinic here in Día Belo, Argentina, home to Atlanta.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('span', [_vm._v("After Selena’s distraught phone call, he’d been sent down here to retrieve the devoted missionary. But Selena took her work very seriously and now she refused to go with him. And Brice couldn’t leave without her. Because she’d had a near run-in with a local guerrilla group known for drug trafficking and smuggling, she was in a lot of danger. Too much danger for the humanitarian organization that had sent her here and too much danger for her rich father back home. They wanted her back in Atlanta. "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Alive")])]), _vm._v(" and well, preferably.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('span', [_vm._v("Brice just wanted her on that plane so he could get out of this rain. “I have my orders,” he shouted over the thunderstorm.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('span', [_vm._v("“And I have my integrity,” she shouted back. “I should have never called you!”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('span', [_vm._v("All around them, the jungle and forest hissed and sang with the rage of the storm. It was wet, humid, flashing both cold and hot, and downright miserable in spite of the beauty of the place.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('span', [_vm._v("“Do you want to die?” he asked, hoping to sway her.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('span', [_vm._v("“No,” she said with an expression full of conviction. “I want to live—to serve these people and God.”")])])]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Brice had enough. Pulling her close with his hands over her elbows, he said, “If you don’t get on that plane, you won’t ever be able to do either again, "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("cara.")])]), _vm._v(" You can’t stay here. It’s too dangerous now. Those men will come back for you, Selena. They’ll figure out you survived the attack.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’m not afraid.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Great. Just what he needed. A brave skinny woman willing to take on some nasty smugglers with her convictions and her honor as her only shields.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Well, you should be afraid,” he shouted. “You saw what they did to your friend Diego and to the others. I can’t let that happen to you.” Getting right in her face, he repeated, his Irish brogue going thick, “It’s time to get on the plane, Selena.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Her violet-blue eyes widened, this time with determination and regret. “I can’t leave them. I can’t. They need me—I give them medicine and tend their wounds. I teach them how to read and tell them the word of God. I can’t leave the clinic. I’m the only one left.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("How did he fight that kind of dedication?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("In the end, he didn’t have a chance.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Bullets hit like a hailstorm all around them, right along with the rain and the wind. With a grunt, Brice picked her up and carried her through the jungle, slapping at ancient vines and wet, prickly palm leaves every step of the way.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("While Selena Carter beat at his chest and his face every step of the way.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-023a5d4d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/codeofhonor_pro.vue
// module id = 81
// module chunks = 0